export enum BackgroundTaskFormats {
  CSV = 'csv',
  XLSX = 'xlsx',
  PDF = 'pdf',
}
